module.exports = __webpack_public_path__ + "static/img/khk001-3.15a5e10c.jpg";